(() => {
	angular.module('main').directive('sendInvoiceModal', sendInvoiceModal);

	sendInvoiceModal.$inject = [];

	function sendInvoiceModal() {
		return {
			scope: true,
			template: require('./sendInvoice.component.html')
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/invoice/sendInvoice.component.js